/** Unique keys for "traffic" module's DTOs */
export enum TrafficsDtoKeysEnum {
  // Adapters
  ADAPTER_FILTERS_DTO = 'traffic/adapter-filters.dto',
  /** Adapter find one API query parameters */
  ADAPTER_FIND_ONE_QUERY_DTO = 'traffic/adapter-find-one-query.dto',
  ADAPTER_QUERY_DTO = 'traffic/adapter-query.dto',
  ADAPTER_FIND_DTO = 'traffic/adapter-find.dto',
  ADAPTER_PAGE_DTO = 'traffic/adapter-page.dto',
  ADAPTER_FORM_DTO = 'traffic/adapter-form.dto',
  ADAPTER_PARTIAL_FORM_DTO = 'traffic/adapter-partial-form.dto',
  /** Adapter selection settings */
  ADAPTER_SELECT_DTO = 'traffic/adapter-select.dto',
  /** Adapter sorting settings */
  ADAPTER_SORT_DTO = 'traffic/adapter-sort.dto',
  // Sensors
  SENSOR_FILTERS_DTO = 'traffic/sensor-filters.dto',
  SENSOR_QUERY_DTO = 'traffic/sensor-query.dto',
  SENSOR_FIND_DTO = 'traffic/sensor-find.dto',
  SENSOR_PAGE_DTO = 'traffic/sensor-page.dto',
  SENSOR_FORM_DTO = 'traffic/sensor-form.dto',
  SENSOR_PARTIAL_FORM_DTO = 'traffic/sensor-partial-form.dto',
  // Traffic
  /** Traffic report own common filters */
  TRAFFIC_REPORT_FILTERS_DTO = 'traffic/traffic-report-filters.dto',
  /** Traffic report items sub-API query parameters */
  TRAFFIC_REPORT_ITEM_QUERY_DTO = 'traffic/traffic-report-item-query.dto',
  /** Traffic report items settings */
  TRAFFIC_REPORT_ITEM_SETTINGS_DTO = 'traffic/traffic-report-item-settings.dto',
  /** Traffic report item */
  TRAFFIC_REPORT_ITEM_DTO = 'traffic/traffic-report-item.dto',
  /** Traffic report items sub-API response body */
  TRAFFIC_REPORT_PAGE_DTO = 'traffic/traffic-report-page.dto',
  /** Traffic report selection settings */
  TRAFFIC_REPORT_SELECT_DTO = 'traffic/traffic-report-select.dto',
  /** Traffic report sorting settings */
  TRAFFIC_REPORT_SORT_DTO = 'traffic/traffic-report-sort.dto',
  /** Traffic plot sub-API query parameters */
  TRAFFIC_PLOT_QUERY_DTO = 'traffic/traffic-plot-query.dto',
  /** Traffic plot settings */
  TRAFFIC_PLOT_SETTINGS_DTO = 'traffic/traffic-plot-settings.dto',
  /** Traffic subtotal item */
  TRAFFIC_SUBTOTAL_ITEM_DTO = 'traffic/traffic-subtotal-item.dto',
  /** Traffic subtotal sub-API query parameters */
  TRAFFIC_SUBTOTAL_QUERY_DTO = 'traffic/traffic-subtotal-query.dto',
  /** Traffic subtotal settings */
  TRAFFIC_SUBTOTAL_SETTINGS_DTO = 'traffic/traffic-subtotal-settings.dto',
  /** Traffic subtotal sub-API response body */
  TRAFFIC_SUBTOTAL_DTO = 'traffic/traffic-subtotal.dto',
}
